import { Dispatch } from "react";
import { Action } from "redux";
import { ExtractAddSlice } from "../../LeftPanel/ExtractAdd";
import { ExtractModes, ICreateExtractState, IExtract } from "../../LeftPanel/ExtractAdd/redux/Types";
import { FinancialSlice } from "../../LeftPanel/FinancialYearList";
import { IExtractList } from "../../LeftPanel/ExtractList/redux/Types";
import { ExtractDetailSelectedTab, Navigation } from "./ExtractNavigation/Types";
import { EXTRACT_DETAIL_SELECTED_TAB } from "./Constant";

interface cancelAlertType {
  /**
   * Flag value to open alert
   */
  openAlert: boolean;
}

/**
 * Method to check the data edited or not for add and edit warnings
 * @param extractAdd - all extract details including mode of excract
 * @param dispatch - dispatch the action
 * @param closeIconClicked - flag value either close icon available
 * @returns cancel alert data
 */
export const validateCloseEditExtract = (
  editExtractDetail: IExtract,
  editPreviousExtractDetail: IExtract,
  extractAdd: ICreateExtractState,
): cancelAlertType => {
  let openAlert;

  if (extractAdd.mode === ExtractModes.EDIT) {
    const checkChanges = JSON.stringify(editExtractDetail) !== JSON.stringify(editPreviousExtractDetail);
    openAlert = checkChanges;
  } else {
    openAlert = false;
  }

  return { openAlert };
};

/**
 * To navigate to dashboard after user confirmation in prompt
 * @param dispatch function to dispatch
 * @param selectedExtract extract id
 */
export const onExtractCancelClick = (
  dispatch: Dispatch<Action>,
  selectedExtract: IExtractList | null
): void => {
  dispatch(ExtractAddSlice.actions.setExtractMode(ExtractModes.VIEW));
  dispatch(FinancialSlice.actions.selectedYear(selectedExtract?.financialYear as string));
};

/**
 * To retrieve the selected tabs from the session storage.
 * @returns  An array of selected tabs. If no tabs are stored, returns an empty array.
 */
export const getStoredTabs = (): ExtractDetailSelectedTab[] => {
  const storedSelectedTabs = sessionStorage.getItem(EXTRACT_DETAIL_SELECTED_TAB) as string;
  return storedSelectedTabs ? JSON.parse(storedSelectedTabs) : [];
};

/**
 * To retrieve the selected menu for a given extract ID from the session storage.
 * @param extractId - The ID of the extract to find the selected menu for.
 * @returns The selected menu for the given extract ID
 */
export const getSelectedMenu = (extractId: string): Navigation => {
  const storedTabs = getStoredTabs();
  const existingTab = storedTabs?.find((item: ExtractDetailSelectedTab) => item.extractId === extractId);
  return existingTab ? existingTab.selectedTab : Navigation.DETAILS;
};

/**
 * To Add or Update the stored tabs in the session storage
 * @param extractId - The ID of the extract.
 * @param selectedTab - The selected tab to store for the given extract ID.
 */
export const updateStoredTabs = (extractId: string, selectedTab: Navigation): void => {
  const storedTabs = getStoredTabs();
  const index = storedTabs?.findIndex((item: ExtractDetailSelectedTab) => item.extractId === extractId);

  if (index === -1) {
    storedTabs.push({ extractId, selectedTab });
  } else {
    storedTabs[index].selectedTab = selectedTab;
  }
  sessionStorage.setItem(EXTRACT_DETAIL_SELECTED_TAB, JSON.stringify(storedTabs));
};
